var render = function render(){var _vm=this,_c=_vm._self._c;return _c('track',{attrs:{"src":require("../assets/videos/infomarker/infomarker.de.vtt"),"default":"","id":"infomarkertrack"},on:{"load":function($event){return _vm.setup($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }